module.exports = __webpack_public_path__ + "static/img/9.5439cb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/9.png
// module id = EhWH
// module chunks = 0